// extracted by mini-css-extract-plugin
export default {"container":"LeagueSelector_container_bb39d","leagueImage":"LeagueSelector_leagueImage_dc75f","leagueText":"LeagueSelector_leagueText_d81b2"};